module.exports = "/images/studio33.png?ddd6b3f51dd3f294a146f3de835f8182";